import {createAction} from '@reduxjs/toolkit';
import {CreatePubEditorDTO} from 'typescript/dto/createPubEditorDTO';
import {UpdateSinglePubDTO} from 'typescript/dto/updateSinglePub';
import {withPayloadType} from 'typescript/types/PayloadType';

import {pubPageNamespace} from './pubPageSlice';

const getSinglePubACS = createAction(`${pubPageNamespace}/getSinglePubACS`, withPayloadType<string>());
const assignPubEditorACS = createAction(`${pubPageNamespace}/createPubEditor'`, withPayloadType<CreatePubEditorDTO>());
const unassignPubEditorACS = createAction(
  `${pubPageNamespace}/unassignPubEditorACS`,
  withPayloadType<{pubId: string; editorId: string; userId: string}>(),
);
const getPubEditorsACS = createAction(
  `${pubPageNamespace}/getPubEditorsACS`,
  withPayloadType<{pubId: string; column?: string; direction?: 'asc' | 'desc'}>(),
);
const updateSinglePubACS = createAction(
  `${pubPageNamespace}/updateSinglePubACS`,
  withPayloadType<UpdateSinglePubDTO>(),
);

export {getSinglePubACS, updateSinglePubACS, getPubEditorsACS, unassignPubEditorACS, assignPubEditorACS};
